// extracted by mini-css-extract-plugin
module.exports = {"productConfiguration":"styles__productConfiguration___31_rE","componentTitle":"styles__componentTitle___2Yb0c"};